import { useMutation, useQueryClient } from '@tanstack/react-query';
import { httpClient } from '@/utils/httpClient';

interface UpdateTransactionNotesArgs {
  transactionId: string;
  notes: string | null;
}

interface UpdateTransactionNotesResponse {
  id: string;
  notes: string | null;
}

export const useUpdateTransactionNotes = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      transactionId,
      notes,
    }: UpdateTransactionNotesArgs): Promise<UpdateTransactionNotesResponse> => {
      return httpClient.patch<UpdateTransactionNotesResponse>(
        `/api/v1/transactions/${transactionId}/notes`,
        { notes },
      );
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['transaction-log'] });
      queryClient.invalidateQueries({ queryKey: ['transaction-log-detail', variables.transactionId] });
    },
  });
};
